<template>
    <div v-if="menuBanners.length" class="brands mt-3 mt-sm-0" @click="$emit('hideMenu')">
      <div class="brands__title mb-0 fwb fs-14">{{ dictionary.brands }}</div>
      <!-- Link -->
      <template v-if="isPwa">
        <a v-for="(item, index) in menuBanners"
            @click.prevent="$emit('redirectToUrl', $event)"
            :key="index"
            :href="item.url"
            class="brands__item"
            :id="`brands-item-${item.id}`"
            :title="item.title"
        >
          <img :src="item.image" :alt="item.title" loading="lazy" />
        </a>
      </template>
      <template v-else>
        <a v-for="(item, index) in menuBanners"
           :key="index"
           :href="item.url"
           class="brands__item"
           :id="`brands-item-${item.id}`"
           :title="item.title"
        >
          <img :src="item.image" :alt="item.title" loading="lazy" />
        </a>
      </template>
    <!-- ense Link -->
    </div>
</template>

<script>
export default {
    props: {
        isPwa: {
            type: Boolean,
            required: true,
        },
        menuBanners: {
          type: Array,
          required: true,
        },
        dictionary: {
            type: Object,
            required: true,
        },
    },
}
</script>

<style lang="scss" scoped>
.brands {
    display: grid;
    gap: 15px;
    grid-template-columns: 1fr 1fr;

    @media (max-width: 980px) {
        position: relative;
        right: 0;
        padding: 15px;
    }

    &__title {
      display: block;
      grid-column: span 2;
    }

    &.mobile-brands {
        position: relative;
        width: 100%;
        right: 0;
        padding: 20px;
    }

    h4 {
        display: block;
        grid-column: span 2;
    }

    &__item {
        background: #fff;
        box-shadow: 0 0 17px -6px #00000038;
        padding: 0.75em 1em;
        height: 90px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 10px;
        transition: all 0.5s;

        @media (max-width: 1200px) {
            padding: 0.75em 2em;
        }

        img {
          transition: all 0.5s;
          height: auto;
          max-width: 60%;
          max-height: 80px;
        }

        &:hover {
            box-shadow: 0 0 17px -6px #00000075;
        }
    }
}
</style>
